import { Check } from 'lucide-react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function PictureChoiceInput({
  question,
  value,
  onChange,
}: AnswerInputProps<string | string[]>) {
  const values = Array.isArray(value) ? value : value ? [value] : []
  const multiple = Boolean(question.settings.allowMultiple)

  function select(choiceValue: string) {
    if (multiple) {
      onChange(
        values.includes(choiceValue)
          ? values.filter((item) => item !== choiceValue)
          : [...values, choiceValue],
      )
      return
    }
    onChange(choiceValue)
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {question.choices.map((choice) => {
          const selected = values.includes(choice.value)
          return (
            <button
              key={choice.id}
              type="button"
              onClick={() => select(choice.value)}
              className={`relative overflow-hidden rounded-lg border bg-white text-left ${
                selected
                  ? 'border-[var(--form-accent,#6366F1)] ring-2 ring-indigo-100'
                  : 'border-slate-200'
              }`}
            >
              <div
                className="grid h-36 place-items-center overflow-hidden bg-gradient-to-br from-indigo-100 to-violet-100 text-sm text-slate-500"
                style={{ borderRadius: choice.imageRadius ?? undefined }}
              >
                {choice.imageUrl ? (
                  <img
                    src={choice.imageUrl}
                    alt={choice.imageAlt || choice.label}
                    className="size-full"
                    style={{
                      objectFit: choice.imageFit ?? 'cover',
                      objectPosition: `${choice.imageFocalX ?? 50}% ${choice.imageFocalY ?? 50}%`,
                      transform: `scale(${choice.imageZoom ?? 1})`,
                      transformOrigin: `${choice.imageFocalX ?? 50}% ${choice.imageFocalY ?? 50}%`,
                    }}
                  />
                ) : (
                  <span>尚未上傳圖片</span>
                )}
              </div>
              <div className="p-3 font-medium">{choice.label}</div>
              {selected && (
                <span className="absolute right-2 top-2 grid size-7 place-items-center rounded-full bg-indigo-600 text-white">
                  <Check className="size-4" />
                </span>
              )}
            </button>
          )
        })}
      </div>
      {question.settings.showOther ? (
        <div className="rounded-lg border border-dashed border-slate-300 bg-white p-3 text-sm text-slate-500">
          其他：填答者可補充沒有出現在圖片選項中的答案。
        </div>
      ) : null}
      {question.settings.randomize ? (
        <div className="text-xs text-slate-500">公開填答時會依設定隨機排列圖片選項。</div>
      ) : null}
    </div>
  )
}
